export default __webpack_public_path__ + "static/media/logo-instituto.c26646d6.png";